import { StringToUInt8 } from "@pdfking/tfunc"

import { GetLastError } from "./GetLastError"
import type { InternalPDFDocument } from "./InternalTypes"

type NewType = InternalPDFDocument

/**
 * Copies pages from one PDF document to another at a specified position
 *
 * @param from_doc Source PDF document (document to copy FROM)
 * @param to_doc Destination PDF document (document to copy TO)
 * @param insert_at Position in destination document to insert the pages (0-based index).
 * @returns Promise that resolves when the pages are copied
 */
export const CopyPage = async (
  { pdfium, doc_pointer }: InternalPDFDocument,
  to_doc: NewType,
  insert_at: number
): Promise<void> => {
  // Copy all pages from source document
  const page_range = ""

  // Convert JavaScript string to C string
  const page_range_byte_size = StringToUInt8(page_range).length + 1
  const pageRangePtr = pdfium.pdfium.wasmExports.malloc(page_range_byte_size)
  pdfium.pdfium.stringToUTF8Helper(
    page_range,
    pageRangePtr,
    page_range_byte_size
  )

  // Import the page from source document to destination document
  const import_operation = pdfium.ImportPages(
    to_doc.doc_pointer, // Destination document
    doc_pointer, // Source document
    pageRangePtr, // Page range string
    insert_at - 1 // Index where to insert in destination doc
  )

  // Check if the operation was successful
  if (!import_operation) {
    throw GetLastError(pdfium)
  }

  pdfium.pdfium.wasmExports.free(pageRangePtr)
}
